import DisplayName from 'components/Presentation/DisplayName';
import React, { Component } from 'react';

class UserSectionPreschool extends Component {

	render() {
		return (
			<div>
				<table className="status-list">
					<tbody>
						{this.props.group?.members
							.sort((a, b) => (a.lastName || "").localeCompare(b.lastName || ""))
							.map((student) => {
								return (
									<tr key={student.id}>
										<td className="name">
											<DisplayName
												firstName={student.firstName}
												lastName={student.lastName}
												email={student.email}
												data={this.props.group?.members}
											/>
										</td>

										<td className="assessment-bar">
										</td>

									</tr>
								);
							})}
					</tbody>
				</table>
			</div>
		);
	}

}

export default UserSectionPreschool;